<script>
import demo from './Template/index'

export default {
  ...demo,
  data () {
    return {
      tab: 'Lot11P5'
    }
  }
}
</script>
